<template>
  <div class="story-programmer-style">
    <wt-dropdown-view
      v-if="isRelevant"
      ref="dropdown"
      type="right"
      :transientView="true"
      @opened="onOpened"
      @closed="onClosed"
    >
      <template v-slot:label>
        <wt-button
          :class="['change-brand-button', open ? 'wt-button-active' : '']"
          type="transparent"
          icon="wticon-pallete"
          :text="currentStoryBrandName"
          :title="currentStoryBrandName"
        >
          <template v-slot:suffix>
            <i
              :class="[
                'wticon',
                open ? 'wticon-chevron-up' : 'wticon-chevron-down',
                '-chevron',
              ]"
            />
          </template>
        </wt-button>
      </template>
      <template v-slot:view="actions">
        <div class="-programmers-panel">
          <div class="wt2-text-m2 -title">
            {{ 'story.changeStyle.title' | culture }}
          </div>
          <section>
            <main>
              <wt-radio-box
                v-for="radio in brandsList"
                :key="radio.value"
                :data-id="radio.value"
                group="some-group"
                :selected="radio.selected"
                :value="radio.value"
                :labelRight="radio.label"
                :title="radio.label"
                @select="onSelectionChange"
              />
            </main>
            <!-- <programmer-style-image
              v-if="selectedBrand"
              :programmerId="selectedBrand.programmerId"
              :brandId="selectedBrand.brandId"
            /> -->
          </section>
          <footer>
            <aside
              v-if="currentBrandNotSupported"
              class="-msg-panel"
              v-text="noBrands4aspectRatio"
            />
            <wt-button
              :text="'generic.CANCEL' | culture"
              type="transparent"
              @click="onCancel(actions.close)"
            />
            <wt-button
              :title="
                hasUploadsInProgress ? culture.story.changeStyle.uploading : ''
              "
              :text="checking || waitingForDialog ? '' : culture.generic.DONE"
              :processing="checking || waitingForDialog"
              :disabled="
                (hasUploadsInProgress &&
                  currentBrandMixedId !== selectedBrandMixedId) ||
                checking ||
                waitingForDialog ||
                !selectedBrand ||
                currentBrandNotSupported
              "
              @click="onSelect(actions.close)"
            />
          </footer>
        </div>
      </template>
    </wt-dropdown-view>
  </div>
</template>

<script>
import app from 'app';
import Vue from 'vue';
// import ProgrammerStyleImage from './ProgrammerStyleImage.vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
  components: {
    // ProgrammerStyleImage,
  },

  data() {
    return {
      culture: app.culture,
      open: false,
      checking: false,
      waitingForDialog: false,
      currentBrandMixedId: null,
      selectedBrandMixedId: null,
      hasUploadsInProgress: !app.UploadQueue.unfinished.isEmpty(),
    };
  },

  computed: {
    ...mapState({
      uploadingAssetsToDisplay: (state) =>
        state.assetGallery.galleryUploadingAssets,
      storyAspectRatio: (state) => state.story?.themeInfo.aspectRatio,
    }),
    ...mapGetters('user', ['selectedOrganization']),
    ...mapGetters(['storyBrand']),

    currentStoryBrandName() {
      return this.$store.getters['storyBrand']
        ? this.storyBrand.name
        : '(obsolete)';
    },

    isRelevant() {
      return this.brandsList.length > 1;
    },

    brandsList() {
      return this.selectedOrganization.brands.map((brand) => {
        return {
          label: brand.name,
          value: brand._mixedId,
          selected: brand._mixedId === this.selectedBrandMixedId,
        };
      });
    },

    selectedBrand() {
      return this.selectedOrganization.brands.find(
        (brand) => brand._mixedId === this.selectedBrandMixedId
      );
    },

    selectedTheme() {
      return this.selectedBrand?.themes.find(
        (theme) => theme.aspectRatio === this.storyAspectRatio
      );
    },

    currentBrandNotSupported() {
      let rv = false;
      if (this.selectedBrand) {
        const theme = this.selectedBrand.themes.find(
          (theme) => theme.aspectRatio === this.storyAspectRatio
        );
        rv = !theme;
      }
      return rv;
    },

    noBrands4aspectRatio() {
      const ar = app.ASPECT_RATIOS[this.storyAspectRatio];
      return ar
        ? app.culture
            .get('makeCopyDialog.noBrands4aspectRatio')
            .format(ar.friendlyVal)
        : '';
    },
  },

  methods: {
    onOpened() {
      this.open = true;
    },

    onClosed() {
      this.selectedBrandMixedId = this.currentBrandMixedId;
      this.open = false;
    },

    async onSelect(close) {
      if (this.currentBrandMixedId === this.selectedBrandMixedId) {
        return this.onCancel(close);
      }
      this.checking = true;

      const check = await app.api.draftStories.disabledCustomOverlays({
        storyId: this.$store.state.story.id,
        targetProgrammerId: this.selectedBrand.programmerId,
        themeId: this.selectedTheme.themeId,
      });

      const hasIssues = !!check?.disabledCustomOverlays?.length;

      if (hasIssues) {
        this.waitingForDialog = true;
        app.dialog
          .error({
            type: app.dialog.types.ERROR_3,
            title: app.culture.story.changeStyle.title,
            description: app.culture.confirm.coConflict.caption.default,
            showContactCsm: false,
            buttonYesText: 'Yes, continue',
            buttonYesAction: true,
            buttonNoAction: false,
          })
          .then(({ action }) => {
            if (action) {
              this.changeStyleToSelected();
            }
            this.waitingForDialog = false;
            this.checking = false;
          });
      } else {
        this.changeStyleToSelected();
      }
    },

    onCancel(close) {
      this.selectedBrandMixedId = this.currentBrandMixedId;
      close();
    },

    onSelectionChange(mixedId) {
      this.selectedBrandMixedId = mixedId;
    },

    changeStyleToSelected() {
      app.storyController.changeStyle({
        targetProgrammerId: this.selectedBrand.programmerId,
        brandId: this.selectedBrand.brandId,
        themeId: this.selectedTheme.themeId,
      });
    },

    $_uploadQueue_changed(newValue) {
      this.hasUploadsInProgress = !app.UploadQueue.unfinished.isEmpty();
    },
  },

  beforeDestroy() {
    app.stopListening(
      app.UploadQueue.unfinished,
      'add remove',
      this.$_uploadQueue_changed
    );
  },

  created() {
    if (this.storyBrand) {
      this.currentBrandMixedId = this.storyBrand._mixedId;
      this.selectedBrandMixedId = this.storyBrand._mixedId;
    }

    app.listenTo(
      app.UploadQueue.unfinished,
      'add remove',
      this.$_uploadQueue_changed
    );
  },
});
</script>

<style lang="scss">
button {
  &.change-brand-button.wt-button {
    padding-left: 15px;
    padding-right: 15px;
    > span {
      max-width: 209px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    .-chevron {
      font-size: 16px;
      margin-left: 15px;
      margin-right: 0;
    }
  }
}

.-box {
  margin-top: -1px;
}

.-programmers-panel {
  width: 400px;
  .-title {
    padding: 15px;
  }
  section {
    display: flex;
    padding-left: 15px;
    border-bottom: 1px solid #d9d9d9;
    min-height: 188px;
    main {
      flex: 1 1 auto;
      height: 187px;
      overflow-y: auto;
      padding: 0 0 20px;
      .wt2-radio-box-component {
        &:not(:nth-last-of-type(1)) {
          margin-bottom: 1em;
        }
        .-label-right {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 255px;
        }
      }
    }
  }

  footer {
    display: flex;
    justify-content: flex-end;

    .-msg-panel {
      color: $color-error;
      flex-grow: 1;
      align-self: center;
      margin-left: 20px;
    }
  }
}
</style>
